/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Participant_Status_DroppedInputs */



/**
* | output |
* | --- |
* | "Dropped" |
*
* @param {Tournaments_Lib_Participant_Status_DroppedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_participant_status_dropped = /** @type {((inputs?: Tournaments_Lib_Participant_Status_DroppedInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Participant_Status_DroppedInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgestiegen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Abandon")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("已退赛")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("已退賽")
	if (locale === "ko") return /** @type {LocalizedString} */ ("기권")
	return /** @type {LocalizedString} */ ("Dropped")
});